import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResponseApi } from '../../../dtos/ResponseApi';
import { ClienteResponse } from '../../../dtos/core/cliente/ClienteResponse';
import { CreateClienteDto } from '../../../dtos/core/cliente/CreateClienteDto';
import { UpdateClienteDto } from '../../../dtos/core/cliente/UpdateClienteDto';
import { ClienteEscolasResponse } from '../../../dtos/core/cliente/ClienteEscolaResponse';
import { UpInsertClienteConfiguracaoDto } from '../../../dtos/core/cliente/cliente-configuracao/UpInsertClienteConfiguracaoDto';
import { ClienteConfiguracaoResponse } from '../../../dtos/core/cliente/cliente-configuracao/ClienteConfiguracaoResponse';
import { CodigosClienteDto } from '../../../dtos/core/cliente/CodigosClienteDto';

@Injectable({
  providedIn: 'root'
})
export class ClienteService {
  private baseUrl = `${environment.apiUrl}/core/cliente`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<ResponseApi<ClienteResponse[]>> {
    return this.http.get<ResponseApi<ClienteResponse[]>>(this.baseUrl);
  }

  getClienteLogged(): Observable<ResponseApi<ClienteResponse>> {
    return this.http.get<ResponseApi<ClienteResponse>>(`${this.baseUrl}/clienteLogged`);
  }

  create(request: CreateClienteDto): Observable<ResponseApi<ClienteResponse>> {
    return this.http.post<ResponseApi<ClienteResponse>>(this.baseUrl, request);
  }

  update(request: UpdateClienteDto): Observable<ResponseApi<ClienteResponse>> {
    return this.http.put<ResponseApi<ClienteResponse>>(this.baseUrl, request);
  }

  delete(id: string): Observable<ResponseApi<void>> {
    return this.http.delete<ResponseApi<void>>(`${this.baseUrl}/${id}`);
  }

  getEscolasParaEstatisticas(): Observable<ResponseApi<ClienteEscolasResponse>> {
    return this.http.get<ResponseApi<ClienteEscolasResponse>>(`${this.baseUrl}/escolas`);
  }

  getClienteByUsuario(): Observable<ResponseApi<ClienteResponse[]>> {
    return this.http.get<ResponseApi<ClienteResponse[]>>(`${this.baseUrl}/clienteByUsuario`);
  }

  upInsertClienteConfiguracao(request: UpInsertClienteConfiguracaoDto): Observable<ResponseApi<ClienteConfiguracaoResponse>> {
    return this.http.post<ResponseApi<ClienteConfiguracaoResponse>>(`${this.baseUrl}/upInsertClienteConfiguracao`, request);
  }


getCodigosByEstadoAndMunicipio(nomeEstado: string, nomeMunicipio: string): Observable<ResponseApi<CodigosClienteDto>> {
    const estadoEncoded = encodeURIComponent(nomeEstado);
    const municipioEncoded = encodeURIComponent(nomeMunicipio);
    return this.http.get<ResponseApi<CodigosClienteDto>>(`${this.baseUrl}/codigos/${estadoEncoded}/${municipioEncoded}`);
  }
}
